<template>
  <div>
    <p>Copyright © 2021 </p>
  </div>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style scoped>
p{
  height: 26px;
  line-height: 26px;
  text-align: right;
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Footer/bottom.vue